import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import axios from 'axios';
import Login from './pages/Login';
import EsqueceuSenha from './pages/EsqueceuSenha';
import DashboardAdmin from './pages/DashboardAdmin';
import DashboardGestor from './pages/DashboardGestor';
import FichaSemanal from './pages/FichaSemanal';
import ScorecardView from './pages/ScorecardView';
import RelatorioDiario from './pages/RelatorioDiario';
import RecrutamentoSilver from './pages/RecrutamentoSilver';
import RecrutamentoDashboard from './pages/RecrutamentoDashboard';
import Documentos from './pages/Documentos';
import { Toaster } from './components/ui/sonner';
import './App.css';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Setup axios interceptor
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const response = await axios.get(`${API}/auth/me`);
        setUser(response.data);
      } catch (error) {
        localStorage.removeItem('token');
        setUser(null);
      }
    }
    setLoading(false);
  };

  const handleLogin = (userData, token) => {
    localStorage.setItem('token', token);
    setUser(userData);
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    setUser(null);
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-50">
        <div className="text-center">
          <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-remax-blue"></div>
          <p className="mt-4 text-gray-600">Carregando...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route
            path="/login"
            element={!user ? <Login onLogin={handleLogin} /> : <Navigate to="/" />}
          />
          <Route path="/esqueceu-senha" element={<EsqueceuSenha />} />
          <Route
            path="/"
            element={
              user ? (
                user.email === 'talianesaldanha@remax.com.br' ? (
                  <Navigate to="/recrutamento-silver" replace />
                ) : user.role === 'administrador' ? (
                  <DashboardAdmin user={user} onLogout={handleLogout} />
                ) : user.role === 'gestor' ? (
                  <DashboardGestor user={user} onLogout={handleLogout} />
                ) : (
                  <Navigate to="/login" />
                )
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/ficha-semanal/:corretorId"
            element={
              user && (user.role === 'administrador' || user.role === 'gestor') ? (
                <FichaSemanal user={user} onLogout={handleLogout} />
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/scorecard/:scorecardId"
            element={
              user && (user.role === 'administrador' || user.role === 'gestor') ? (
                <ScorecardView user={user} onLogout={handleLogout} />
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/relatorio-diario"
            element={
              user && (user.role === 'administrador' || user.role === 'gestor') ? (
                <RelatorioDiario user={user} onLogout={handleLogout} />
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/recrutamento-dashboard"
            element={
              user && (user.role === 'administrador' || user.role === 'gestor' || user.email === 'talianesaldanha@remax.com.br') ? (
                <RecrutamentoDashboard 
                  user={user} 
                  token={localStorage.getItem('token')}
                  onLogout={handleLogout} 
                />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/recrutamento-silver"
            element={
              user && (user.role === 'administrador' || user.role === 'gestor' || user.email === 'talianesaldanha@remax.com.br') ? (
                <RecrutamentoSilver 
                  user={user} 
                  token={localStorage.getItem('token')}
                  onLogout={handleLogout} 
                />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/documentos"
            element={
              user ? (
                <Documentos 
                  user={user} 
                  token={localStorage.getItem('token')}
                  onLogout={handleLogout} 
                />
              ) : (
                <Navigate to="/login" />
              )
            }
          />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
